import React from "react";

import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";

import { ReactComponent as IconPlay18 } from "../../icons/icon/18/a-icon-play-18.svg";
import Button from "../button/button";

import "./videoBackgroundPlayer.scss";

interface PlayVideoButtonProps {
  videoPlayerRef: React.RefObject<{
    openVideo: () => void;
  }>;
}

const PlayVideoButton: React.FC<PlayVideoButtonProps> = ({ videoPlayerRef }) => {
  const intl = useIntl();

  return (
    <Button
      onClick={() => {
        videoPlayerRef.current?.openVideo();
      }}
      variant="text-light"
      className="video-background-player__video-button"
      title={intl.formatMessage({ id: "video.play" })}
    >
      <IconPlay18 className="mr-9" /> <FormattedMessage id="video.play" />
    </Button>
  );
};

export default PlayVideoButton;
